import React, { useState } from 'react';
import { trackEvent } from '../utils/analytics';

const ContactForm = ({ language }) => {
    const [result, setResult] = useState("");
    const [status, setStatus] = useState("idle"); // idle, sending, success, error

    const translations = {
        en: {
            name: "Full Name",
            email: "Email Address",
            message: "Your Message",
            send: "Send Message",
            sending: "Sending...",
            success: "Message sent successfully!",
            error: "Something went wrong. Please try again.",
            required: "This field is required",
        },
        cs: {
            name: "Celé jméno",
            email: "E-mailová adresa",
            message: "Vaše zpráva",
            send: "Odeslat zprávu",
            sending: "Odesílám...",
            success: "Zpráva byla úspěšně odeslána!",
            error: "Něco se nepovedlo. Zkuste to prosím znovu.",
            required: "Toto pole je povinné",
        },
        de: {
            name: "Vollständiger Name",
            email: "E-Mail-Adresse",
            message: "Ihre Nachricht",
            send: "Nachricht senden",
            sending: "Senden...",
            success: "Nachricht erfolgreich gesendet!",
            error: "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
            required: "Dieses Feld ist erforderlich",
        }
    };

    const t = translations[language] || translations.en;

    const onSubmit = async (event) => {
        event.preventDefault();
        setStatus("sending");
        setResult(t.sending);
        const formData = new FormData(event.target);

        // Web3Forms Configuration
        formData.append("access_key", "d375fdb7-f638-40a4-bcd4-2e01a46a6c11");
        formData.append("from_name", formData.get("name") || "Beystreng Website");
        const subject = language === 'cs' ? "Nová zpráva z webu Beystreng" :
            (language === 'de' ? "Neue Nachricht von Beystreng Website" : "New Message from Beystreng Website");
        formData.append("subject", subject);

        const response = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            body: formData
        });

        try {
            const data = await response.json();

            if (data.success) {
                trackEvent("Lead", "Contact Form", "Success");
                setStatus("success");
                setResult(t.success);
                event.target.reset();
            } else {
                trackEvent("Lead", "Contact Form", "Error - API");
                console.error("Web3Forms Error:", data);
                setStatus("error");
                // Show specific message from Web3Forms if available
                setResult(data.message || t.error);
            }
        } catch (error) {
            trackEvent("Lead", "Contact Form", "Error - Catch");
            console.error("Submission Error:", error);
            setStatus("error");
            setResult(t.error);
        }
    };

    return (
        <div className="max-w-xl mx-auto mt-8 sm:mt-12 p-4 sm:p-6 bg-white rounded-xl shadow-lg">
            <form onSubmit={onSubmit} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t.name}</label>
                    <input
                        type="text"
                        name="name"
                        required
                        placeholder={t.name}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all text-gray-800"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t.email}</label>
                    <input
                        type="email"
                        name="email"
                        required
                        placeholder={t.email}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all text-gray-800"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t.message}</label>
                    <textarea
                        name="message"
                        required
                        rows="4"
                        placeholder={t.message}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all text-gray-800 resize-none"
                    ></textarea>
                </div>

                <button
                    type="submit"
                    disabled={status === "sending"}
                    className={`w-full py-3 rounded-lg font-bold text-white transition-all shadow-md
            ${status === "sending" ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 active:scale-95'}`}
                >
                    {status === "sending" ? t.sending : t.send}
                </button>

                {
                    status !== "idle" && (
                        <div className={`text-center p-3 rounded-lg text-sm font-medium animate-fade-in
            ${status === "success" ? 'bg-green-100 text-green-700 border border-green-200' : 'bg-red-100 text-red-700 border border-red-200'}`}>
                            {result}
                        </div>
                    )
                }
            </form >
        </div >
    );
};

export default ContactForm;
